import { createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';
import PoppinsRegular from '../../assets/fonts/Poppins-Regular.ttf';

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, Arial',
    fontSize: 13
  },
  components: {
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: '#FAE268',
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderBottomWidth: 1,
          borderBottomStyle: 'solid',
          borderBottomColor: '#FAE268',
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffFFFDEF',
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: '#FAE268',
          "&:hover": {
            backgroundColor: '#ffFFFDEF',
            borderBottom: 'none',
          },
          "&.Mui-disabled": {
            backgroundColor: '#FFF7B0',
          }
        },
        underline: {
          "&:hover": {
            borderBottom: "1px solid transparent",
          },
          "&:before": {
            borderBottom: '1px solid transparent',
          },
          "&:after": {
            borderBottom: '1px solid transparent',
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        filled: {
          color: '#323232ff',
          "&.Mui-focused": {
            color: '#323232ff',
          },
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#323232',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Poppins'), local('Poppins-Regular'), url(${PoppinsRegular}) format('truetype');
        }
      `
    }
  },
  palette: {
    primary: {
      main: '#FAE268',
      light: '#FFF7B0',
      "200": '#ffFFFDEF',
      contrastText: '#323232',
    },
    secondary: {
      main: '#CCDCC0',
      contrastText: '#323232',
    },
    success: {
      main: '#89c480ff',
      light: '#c5e2bfff',
      contrastText: '#323232',
    },
    warning: {
      main: '#f4ab84ff',
      contrastText: '#323232',
    },
    error: {
      main: '#fe8f86ff',
      light: '#ffc9c2ff',
      contrastText: '#323232',
    },
    common: {
      black: '#323232ff',
      white: '#ffFFFFFF',
    }
  },
}, esES );

export default theme;
